<template>
    <div class="col-md-12">
        <div class="">
            <div class="h2">Recurring jobs</div>
            <div class="position-relative pagination-control">
                <data-table
                    :url="url"
                    :filters="filters"
                    :columns="columns"
                    :per-page="perPage"
                    :classes="classes"
                    :order-by="orderBy"
                    :order-dir="orderDir"
                    :meta="columns.meta"
                >
                    <div slot="filters" slot-scope="{ tableFilters, perPage, drivers }">
                        <div class="row my-3 d-flex justify-content-end align-items-left">
                            <div class="col-md-3">
                                <div
                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                        <span class="material-icons-outlined cursor-pointer">search</span>
                                    </button>
                                    <input name="name" v-model="filters.search"
                                           class="form-control form-control border-0 py-0 pl-0 shadow-none form-input"
                                           placeholder="Search"/>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <a href="/recurrings/create"
                                   class="btn btn-success float-right d-flex align-items-center"
                                   title="Create new recurring job">
                                    <span class="material-icons-outlined cursor-pointer mr-1">post_add</span>
                                    <span>Create recurring job</span>
                                </a>
                            </div>
                        </div>
                        <br/>
                    </div>
                    <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                    <tr>
                        <th @click="sort(column.id)" v-if="column.label!==''"
                            v-for="column in columns">
                            <span> {{ column.label }} </span>
                        </th>
                    </tr>
                    </thead>
                    <tbody slot="body" slot-scope="{ data }">
                    <tr
                        :key="recurring.id"
                        v-for="(recurring,key) in data">
                        <td
                            :key="column.name"
                            v-for="column in columns"
                        >
                            <data-table-cell
                                :value="recurring"
                                :name="column.name"
                                :meta="column.meta"
                                :comp="column.component"
                                :classes="column.classes">
                            </data-table-cell>

                            <slot v-if="column.label === 'Driver'">
                                {{ recurring.driver.name }}
                            </slot>

<!--                            <slot v-if="column.label === 'Company'">-->
<!--                                {{ recurring.driver.company ? recurring.driver.company.name : '' }}-->
<!--                            </slot>-->


                            <slot v-if="column.label === 'Client'">
                                {{ recurring.client.name }}
                            </slot>

                            <slot v-if="column.label === 'Edit'">
                                <a :href="`/recurrings/${recurring.id}/edit`" title="Edit Recurring Job">
                                    <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                </a>
                            </slot>
                        </td>
                    </tr>
                    </tbody>
                </data-table>
            </div>
            <br/>
            <div class="d-flex justify-content-between">
                <div>
                    <label class="pr-2">Jobs per page:</label>
                    <div class="d-inline-flex center bg-white border rounded-lg div-focus border-2">
                        <select class="form-control bg-white border-0 py-0 shadow-none"
                                v-model="filters.length"
                                style="width: 150px;">
                            <option
                                :key="index"
                                :value="records"
                                v-for="(records, index) in perPage">
                                {{ records }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RecurringDataTable",
    props: {
        url: {type: String, required: true},
    },
    data() {
        return {
            orderBy: 'id',
            orderDir: 'desc',
            search: '',
            perPage: [100, 10, 25, 50],
            filters: {
                search: '',
                length: 100,
                column: 'id',
                dir: 'desc',
                type: '',
            },
            columns: [
                {
                    label: 'Name',
                    name: 'name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Driver',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Client',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Edit',
                    id: 'edit',
                    orderable: false,
                },
            ],
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
        }
    },
    methods: {
        fetchData() {
            //
        },
    },
    created() {
        return this.fetchData()
    },
}
</script>
